import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-polyglot'

import { Icon } from 'components'

import './filterInput.scss'

class FilterInput extends PureComponent {
	render() {
		const { name, value, onChange, placeholder, t, ...rest } = this.props

		return (
			<div className="c-filter-input">
				<input
					className="c-filter-input__field"
					id={name}
					value={value}
					onChange={onChange}
					placeholder={placeholder || t('filter')}
					{...rest}
				/>
				<label htmlFor={name} className="c-filter-input__label">
					<Icon name="search" />
				</label>
			</div>
		)
	}
}

FilterInput.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	placeholder: PropTypes.string,
}

FilterInput.defaultProps = {
	onChange: null,
	placeholder: null,
}

export default translate()(FilterInput)
